module.exports = __webpack_public_path__ + "img/arrow-right-thin.d0c0c349.svg";